/** Service Desk console: pag-convert ng lead sa organisasyon at contact (ORG-019, SD-S4-07). */
export const serviceLeadConvert = {
  title: "I-convert ang {{name}} sa organisasyon",
  hint: "Walang kumpanya ang lead, kaya pangalanan ang organisasyon. Galing sa lead ang contact; suriin ito bago mag-preview.",
  previewHint: "Ito ang gagawin. Walang masi-save hangga't hindi ka nagko-convert.",
  working: "Ginagawa ang organisasyon at ang contact…",
  step: { form: "Hakbang 1 sa 2: ang organisasyon at ang contact.", preview: "Hakbang 2 sa 2: suriin ang gagawin.", done: "Na-convert ang lead." },
  converted: "Na-convert sa organisasyon",
  convertedTo: "Na-convert sa {{name}}",
  alreadyConverted: "Na-convert na ang lead na ito sa",
  actions: {
    open: "I-convert sa organisasyon",
    preview: "I-preview",
    back: "Bumalik",
    convert: "I-convert ang lead",
  },
  fields: {
    organisation: "Organisasyon",
    organisationName: "Pangalan ng organisasyon",
    organisationNameHint: "Ang kumpanya o institusyon ng kliyente. Dapat bago ito maliban kung ili-link mo sa umiiral sa susunod na hakbang.",
    kind: "Uri",
    domains: "Mga e-mail domain",
    domainsHint: "Opsyonal. Paghiwalayin ng espasyo o kuwit, hanggang {{max}}.",
    contact: "Contact",
    contactName: "Pangalan ng contact",
    contactEmail: "E-mail ng contact",
    contactEmailHint: "Kailangan ng contact ng e-mail address para makapag-sign in.",
    jobTitle: "Posisyon",
    orgRole: "Tungkulin sa organisasyon",
    role: { org_admin: "Admin ng organisasyon", member: "Miyembro" },
  },
  problems: {
    organisationName: "Ilagay ang pangalan ng organisasyon (2 hanggang 160 character).",
    domains: "Gumamit ng simpleng domain tulad ng example.com.ph, isang beses bawat isa.",
    contactName: "Ilagay ang pangalan ng contact.",
    contactEmail: "Maglagay ng wastong e-mail address.",
  },
  preview: {
    title: "Ang gagawin",
    new: "Bago",
    linked: "Umiiral na",
    taken: "Mayroon na",
    linkBack: "May linya ang lead sa timeline nito na tumuturo sa organisasyon, at tumuturo pabalik sa lead ang organisasyon.",
  },
  duplicates: {
    none: "Wala pang organisasyon o contact na katulad nito.",
    title_one: "{{count}} posibleng doble ang natagpuan",
    title_other: "{{count}} posibleng doble ang natagpuan",
    organisation_name: "May organisasyong may ganitong pangalan na:",
    organisation_domain: "Pag-aari na ng sumusunod ang e-mail domain na ito:",
    contact_email: "May contact na may ganitong e-mail address na:",
    link: "I-link ang lead na ito sa umiiral na organisasyon at contact",
    linkHint: "Walang bagong gagawin para sa umiiral na. O bumalik at palitan ang mga pangalan.",
  },
  done: {
    created: "Nagawa ang {{name}} at naidagdag ang contact.",
    linked: "Na-link ang lead sa umiiral na {{name}}.",
    openOrganisation: "Buksan ang {{name}}",
    openContact: "Buksan ang contact na {{name}}",
    recorded: "Nasa timeline ng lead at sa audit log ang conversion.",
  },
  origin: {
    prefix: "Na-convert mula sa lead na",
    on: " noong {{date}}",
  },
  errors: {
    alreadyConverted: "Na-convert na ang lead na ito. Isara ito at i-reload ang lead.",
    duplicates: "May organisasyon o contact nang katulad nito. Mag-preview ulit at i-link sa mga ito, o palitan ang mga pangalan.",
    rights: "Kailangan ng pahintulot na mag-edit ng lead at mag-manage ng organisasyon para mag-convert ng lead.",
    notFound: "Wala na ang lead na ito.",
  },
} as const;
